export default "__VITE_ASSET__DfMXIS6K__"